import type { Maybe, User as GQLUser } from '@/generated/graphql';
import { take } from '@/helpers/takePayload';

export interface User {
  id?: number;
  name?: string;
  email?: string;
  active?: boolean;
}

export const getNew = (): User => ({
  name: '',
  email: '',
});

export const fromGql = (gqlUser?: Maybe<GQLUser>): User => ({
  ...(take(gqlUser || {}, 'id', 'name', 'email', 'active') as User),
});
